import { memo } from 'react'
import { Badge, Flex, ScaleFade } from '@chakra-ui/react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormViewerQuestion from 'components/tools/CustomForm/components/Viewer/components/CustomFormViewerQuestion'
import CustomFormBuilderEditQuestionButton from './components/CustomFormBuilderEditQuestionButton'
import CustomFormBuilderDeleteQuestionButton from './components/CustomFormBuilderDeleteQuestionButton'

type QuestionProps = {
  question: CustomFormQuestion
  index: number
  questionsLength: number
}

function CustomFormBuilderQuestionCard({ question, index, questionsLength }: QuestionProps) {
  return (
    <ScaleFade in={true}>
      <Flex flexDir="column" bg="light" gap={2} border="1px solid" borderColor="borderColor" rounded="md" p={2}>
        <CustomFormViewerQuestion disabled question={question} index={index} questionsLength={questionsLength} />
        <Flex
          alignItems="center"
          justify="space-between"
          gap={2}
          borderTop="1px solid"
          borderColor="borderColor"
          pt={2}
          mt={2}
        >
          <Flex alignItems="center" justify="start" gap={2}>
            {question?.tags && question?.tags.length > 0 && (
              <Badge colorScheme="purple" size="sm">
                Tags: {question?.tags.join(', ')}
              </Badge>
            )}
          </Flex>
          <Flex alignItems="center" justify="end" gap={2}>
            <CustomFormBuilderEditQuestionButton question={question} />
            <CustomFormBuilderDeleteQuestionButton question={question} />
          </Flex>
        </Flex>
      </Flex>
    </ScaleFade>
  )
}

export default memo(CustomFormBuilderQuestionCard)
